(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'degreePage', {
            bindings: { $transition$: '<' },
            templateUrl:  'app/views/degrees/degrees.html',
            controller:   'DegreesController',
            controllerAs: 'vm'
        });
})();
